import styled from "styled-components";
import { Box } from "@mui/material";

export const PageContainer = styled(Box)`
  /* Custom, iPhone Retina */
  @media only screen and (min-width: 320px) {
  }

  /* Extra Small Devices, Phones */
  @media only screen and (min-width: 480px) {
  }

  /* Small Devices, Tablets */
  @media only screen and (min-width: 768px) {
  }

  /* Normal Desktops */
  @media only screen and (min-width: 1680px) {
    && {
      margin-left: 15rem;
      margin-right: 15rem;
    }
  }

  /* Large Devices, Wide Screens */
  @media only screen and (min-width: 2560px) {
    && {
      margin-left: 30rem;
      margin-right: 30rem;
    }
  }
`;
